// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__QjhhK","box":"styles_box__oUa7s","modal_black":"styles_modal_black__qyMKV","modal_contents":"styles_modal_contents__j2h7c"};